import { render, staticRenderFns } from "./CasesCard.vue?vue&type=template&id=79741e22"
import script from "./CasesCard.vue?vue&type=script&lang=js"
export * from "./CasesCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports